import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { OneColumn } from '../Layout';

export const ContentWrapper = styled('div')`
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  ${media.lgUp`
    padding-top: ${({ theme }) => theme.x5spacePx}px;
  `}
`;

export const Content = styled(OneColumn)`
  margin: 0 auto;

  li {
    color: ${({ theme }) => theme.color.spaceGray};
  }
  ${media.lgUp`
    max-width: ${({ theme }) => theme.xlMin};
  `}
  ${media.smDown`
    max-width: ${({ theme }) => theme.mdMin};
  `}
`;

export const PaginationContainer = styled.div`
  margin-top: ${({ theme }) => theme.x8spacePx}px;
  margin-bottom: ${({ theme }) => theme.x6spacePx}px;
`;
